import { useTranslation } from 'react-i18next'
import LoadingIndicator from '@/widgets/LoadingIndicator'
import NoResultsIndicator from '@/widgets/NoResultsIndicator'
import { getSortIndicator } from '@/lib/tableHelpers'
import RozliczeniaTrainersTableRow from './RozliczeniaTrainersTableRow'

export default function RozliczeniaTrainersTable({
	trainers,
	loading,
	sortColumn,
	sortDirection,
	onSort,
}) {
	const { t } = useTranslation()
	const rows = Array.isArray(trainers) ? trainers : []

	if (loading) return <LoadingIndicator />

	if (rows.length === 0) {
		return (
			<NoResultsIndicator
				message={t('rozliczenia.list.emptyState.title')}
				description={t('rozliczenia.list.emptyState.description')}
			/>
		)
	}

	return (
		<div className="mt-6 overflow-x-auto">
			<table className="min-w-full bg-white border border-gray-300 rounded-lg shadow">
				<thead>
					<tr>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							<button
								type="button"
								className="flex items-center font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
								onClick={() => onSort('nazwa')}
							>
								{t('rozliczenia.list.table.name')}
								{getSortIndicator('nazwa', sortColumn, sortDirection)}
							</button>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-center whitespace-nowrap">
							<button
								type="button"
								className="mx-auto flex items-center justify-center font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
								onClick={() => onSort('unsettledMonths')}
							>
								{t('rozliczenia.list.table.unsettledMonths')}
								{getSortIndicator('unsettledMonths', sortColumn, sortDirection)}
							</button>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-right w-48">
							<button
								type="button"
								className="ml-auto flex items-center justify-end font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
								onClick={() => onSort('do_rozliczenia')}
							>
								{t('rozliczenia.list.table.toSettle')}
								{getSortIndicator('do_rozliczenia', sortColumn, sortDirection)}
							</button>
						</th>
					</tr>
				</thead>
				<tbody>
					{rows.map(trainer => (
						<RozliczeniaTrainersTableRow
							key={trainer._id || trainer.id}
							trainer={trainer}
						/>
					))}
				</tbody>
			</table>
		</div>
	)
}
